import { StandardEvents } from '@shopify/events';

/**
 * AYS availability note.
 *
 * The note is rendered above the variant picker, which means it sits outside the
 * <variant-picker> element that Horizon morphs on a variant change. So, like the
 * theme's own product-inventory / product-price / product-sku components, it
 * listens for the product select event and re-renders itself from the returned HTML.
 */
class AysAvailabilityNote extends HTMLElement {
  /** @type {Element | null} */
  #scope = null;

  connectedCallback() {
    this.#scope = this.closest('.shopify-section, dialog');
    this.#scope?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    this.#scope?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
    this.#scope = null;
  }

  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        const { html, newProduct } = detail;

        if (newProduct) {
          this.dataset.productId = newProduct.id;
        } else if (detail.productId && detail.productId !== this.dataset.productId) {
          return;
        }

        const next = html.querySelector('ays-availability-note');
        this.innerHTML = next ? next.innerHTML : '';
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[ays-availability-note] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('ays-availability-note')) {
  customElements.define('ays-availability-note', AysAvailabilityNote);
}
